<template>
  <div class="up-mask flex-box">
    <div class="desc">
      <h2>
        更新通知
      </h2>
      <br />
      <p style="text-align: left;" v-if="isforce">
        抱歉，由于私信宝插件版本过低，现有插件功能已经无法正常使用，我们进行了一系列重大升级，最新版本已经升级到V{{
          version.split('').join('.') ? version : ''
        }}啦！<br /><br />

        还有更多私信平台监控功能陆续加入，立即升级吧！<br /><br />
      </p>
      <p style="text-align: left;" v-else>
        插件发布新版本啦，我们的程序猿对插件进行了一系列升级，提升了稳定性和使用体验，最新版本已经升级到V{{
          version ? version.split('').join('.') : ''
        }}啦！<br /><br />

        还有更多私信平台监控功能陆续加入，立即升级吧！<br /><br />
      </p>
      <a
        href="https://huoke.5118.com/download#update "
        target="_blank"
        class="link"
        >下载更新</a
      >
      <span
        class="link"
        style="margin-left: 5px;"
        @click="close"
        v-if="!isforce"
        >稍后下载</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
  props: ['version', 'isforce'],
  methods: {
    close() {
      this.$emit('listenToCloseBox', false);
    },
  },
};
</script>

<style scoped lang="less" type="text/less">
@import '../../../assets/style/color.less';
@import '../../../assets/style/config.less';
@import '../../../assets/style/mixin.less';

.up-mask {
  background-color: fade(black, 70);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  z-index: 2000;
  text-align: center;
  padding: 0 12px;
  .desc {
    color: white;
    .link {
      margin-top: 30px;
      display: inline-block;
      padding: 0 15px;
      color: #ffffff;
      font-weight: 400;
      font-size: 14px;
      line-height: 35px;
      border-radius: 2px;
      text-decoration: none;
      border: 0;
      outline: 0;
      background: #166df1 none;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/Up/pm_main.vue